/* eslint-disable import/no-cycle */
import React from 'react'

import { useTranslation } from 'react-i18next'
import { connect } from 'react-redux'

import ReservationSearchBox from 'components/forms/reservation-search-box'
import { IconNames } from 'components/icons'
import CONFIG from 'config'
import { searchBox as e2eClasses } from 'constants/e2eClasses'
import { buildURLEncoded } from 'helpers/url'
import { LANGUAGE_TAGS } from 'localization/constants/languages'
import NAMESPACES from 'localization/constants/namespaces'
import { getReservationCode, getReservationData, getReservationName } from 'selectors/reservation'

const CheckInSearchBox = props => {
  const {
    t,
    i18n: { language }
  } = useTranslation(NAMESPACES.HOME)

  const handleButtonClick = (reservationCode, lastName) => {
    props.onReserveError && props.onReserveError()
    const {
      ENGLISH_ONLY_LANG,
      ITALIAN_ONLY_LANG,
      ITALIAN_LOCALE,
      ENGLISH_USA,
      SPANISH,
      FRENCH_ONLY_LANG
    } = LANGUAGE_TAGS
    const lang = language.split('-')[0]

    let locale
    switch (lang) {
      case ENGLISH_ONLY_LANG:
      case FRENCH_ONLY_LANG:
        locale = ENGLISH_USA
        break
      case ITALIAN_ONLY_LANG:
        locale = ITALIAN_LOCALE
        break
      default:
        locale = SPANISH
    }

    const checkinURL = buildURLEncoded('', {
      deepLink: true,
      locale,
      recordLocator: reservationCode,
      lastName: lastName
    })

    props.onCheckInNavigation(`${CONFIG.WEB_CHECKIN_URL}${checkinURL}`)
  }

  return (
    <ReservationSearchBox
      onSearch={handleButtonClick}
      labels={{
        title: t('shopping.search-box-container.begin-check-in'),
        search: t('shopping.search-box-container.begin-check-in.uppercase'),
        codeBox: e2eClasses.checkInBox,
        searchButton: e2eClasses.checkInSearchButton,
        pnr: {
          codeBox: e2eClasses.checkInCodeBox,
          codeTitle: e2eClasses.checkInCodeTitle,
          iconName: IconNames.Airplane,
          labelMobile: t('shopping.search-box-container.pnr-placeholder'),
          label: t('label.reservation-code'),
          code: e2eClasses.checkInCode,
          error: t('shopping.search-box-container.validation.pnr.required')
        },
        lastName: {
          codeBox: e2eClasses.checkInPassengerBox,
          codeTitle: e2eClasses.checkInPassengerTitle,
          iconName: IconNames.HumanMale,
          label: t('label.passenger', { count: 1 }),
          placeholder: t('label.lastname'),
          code: e2eClasses.checkInPassenger,
          error: t('shopping.search-box-container.validation.last-name.required')
        },
        conditions: {
          error: t('general.search-box-container.check-in.dont-forget')
        }
      }}
      isCheckIn
    />
  )
}

const mapStateToProps = state => ({
  reservation: getReservationData(state),
  reservationCode: getReservationCode(state),
  reservationName: getReservationName(state)
})

export default connect(mapStateToProps)(CheckInSearchBox)
